export default __webpack_public_path__ + "static/media/PTSans-Regular.a2a2554b.ttf";